module.exports = __webpack_public_path__ + "img/blogs_layout3.5057665e.png";